import React from 'react';

const PaymentSuccessful = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'linear-gradient(to right, #4facfe, #00f2fe)' }}>
            <div style={{ textAlign: 'center', padding: '20px', borderRadius: '10px', background: 'white', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <h1 style={{ color: '#4caf50', fontSize: '2rem', marginBottom: '10px' }}>Payment Successful</h1>
                <p style={{ color: '#555', fontSize: '1rem' }}>Thank you for your purchase!</p>
            </div>
        </div>
    );
}

export default PaymentSuccessful;